import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as familyAlbumActions from 'Global/Stores/familyAlbum'
import * as layoutActions from 'Global/Stores/layout'
import * as previewModalActions from 'Global/Stores/previewModalGeneric'

import * as selectors from './selectors'

const module = 'familyAlbum'

const pageSet = layoutActions.makePageSet(module)

const FamilyAlbumDetailModule = WrappedComponent => {
  class FamilyAlbumDetailModule extends Component {
    static propTypes = {
      eventName: PropTypes.string.isRequired,
      eventsDone: PropTypes.bool.isRequired,
      eventsError: PropTypes.bool.isRequired,
      eventsPending: PropTypes.bool.isRequired,
      getEvents: PropTypes.func.isRequired,
      isSearchVisible: PropTypes.bool.isRequired,
      pagination: PropTypes.object.isRequired,
      pictures: PropTypes.array.isRequired,
      previewOpen: PropTypes.bool.isRequired,
      previewPictures: PropTypes.array.isRequired,
      setPage: PropTypes.func.isRequired,
      togglePreview: PropTypes.func.isRequired,
    }

    componentDidMount() {
      const { getEvents, eventsDone } = this.props

      if (!eventsDone) {
        getEvents()
      }
    }

    render() {
      const { eventsError, eventsPending } = this.props

      return <WrappedComponent hasError={eventsError} loaderPending={eventsPending && !eventsError} {...this.props} />
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    eventName: selectors.eventName(state, ownProps),
    eventsDone: selectors.eventsDone(state),
    eventsError: selectors.eventsError(state),
    eventsPending: selectors.eventsPending(state),
    isSearchVisible: selectors.isSearchVisible(state),
    pagination: selectors.pagination(state, ownProps),
    pictures: selectors.slicedSortedPictures(state, ownProps),
    previewOpen: selectors.previewOpen(state),
    previewPictures: selectors.previewPictures(state, ownProps),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getEvents: () => dispatch(familyAlbumActions.familyAlbumEventsGet()),
    setCurrentIndex: () => dispatch(previewModalActions.previewModalIndexSet()),
    setPage: page => dispatch(pageSet(page)),
    togglePreview: index => dispatch(previewModalActions.previewModalToggle(index)),
    toggleSearchForm: () => dispatch(familyAlbumActions.familyAlbumSearchFormToggle()),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FamilyAlbumDetailModule)
}

export default FamilyAlbumDetailModule
